import { render, staticRenderFns } from "./CompetitionEditMilestones.vue?vue&type=template&id=a891a34e&"
import script from "./CompetitionEditMilestones.vue?vue&type=script&lang=js&"
export * from "./CompetitionEditMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports